import { useMemo } from "react";
import classNames from "classnames";
import { AnalyticsEvent } from "@common/constants/analytics-events";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { noop } from "@common/helpers/function";
import { BlurOverlay } from "@components/settings/Plans/BlurOverlay";
import { UpgradeCta } from "@components/settings/Plans/UpgradeCta";
import { VStack } from "@design-system/VStack/VStack";
import { generateMockInvoices, mockInvoiceStats } from "@helpers/invoice";
import { useEffectOnce } from "@hooks/useEffectOnce";
import { trackEvent } from "@lib/analytics";
import { InvoiceStats } from "./InvoiceStats";
import { defaultInvoicesView } from "./views/defaultInvoiceViews";
import { InvoicesView } from "./views/invoicesView/InvoicesView";
import styles from "./InvoicingPaywalled.module.scss";

export const InvoicingPaywalled = () => {
    useEffectOnce(() => {
        void trackEvent(AnalyticsEvent.UPSELL_INVOICING_ATTEMPTED);
    });

    const invoices = useMemo(() => generateMockInvoices(10), []);

    return (
        <>
            <div className={styles.ctaContainer}>
                <UpgradeCta
                    title={
                        <>
                            Invoicing is available on the{" "}
                            <span className="text-blue-600">Basic</span> plan
                        </>
                    }
                    subtitle="Create, send and track invoices, and collect payments."
                    plan={FLAT_RATE_PLANS.BASIC}
                />
            </div>
            <VStack
                gap={24}
                className={classNames(
                    styles.invoiceContainer,
                    "p-0 overflow-y-hidden",
                )}
            >
                <InvoiceStats
                    filters={{}}
                    setFilters={noop}
                    invoiceStats={mockInvoiceStats}
                />
                <InvoicesView invoices={invoices} view={defaultInvoicesView} />
            </VStack>
            <BlurOverlay />
        </>
    );
};
